
import WidgetDefaultNuxt from '../default/nuxt.vue';
import { loadJS } from '@/libs/async-load.js';

export default {
  name: 'WidgetRemoteNuxt',
  extends: WidgetDefaultNuxt,
  provide() {
    return {
      rocketOn: this.rocketOn,
      rocketEmit: this.rocketEmit,
      rocketOff: this.rocketOff,
    };
  },
  data() {
    const { values, getLocaleValue } = this;
    // 不支持切换远程组件的资源
    let remote = {
      src: getLocaleValue(values.remote?.src) || '',
      link: getLocaleValue(values.remote?.link),
    };

    let variables = this.values.variables || {
      i18n: ['__variables__', this.nodeId],
    };
    let remoteProps = this.getLocaleValue(variables);

    return {
      mode: '',
      widgetClassName: 'widget-remote',
      defaultProps: {},
      modeName: remote.src.split('/').slice(-1)[0].split('.umd')[0],
      remote,
      remoteProps,
      localePath: [{ key: 'remoteProps', value: variables }],
    };
  },
  head() {
    let updated = this?.file?.pureInfo?.updated || 0;
    return {
      // title: this.title_,
      link: [
        {
          rel: 'stylesheet',
          href: this.remote.link + `${updated ? '?r=' + updated : ''}`,
        },
      ],
      script: [
        // {
        //   src: this.remote.src + `${updated ? '?r=' + updated : ''}`,
        //   defer: true,
        //   callback: () => {
        //     if (this.mode) return;
        //     this.rocketEmit('rocket:remote:load-component:' + this.modeName);
        //   },
        // },
      ],
    };
  },
  computed: {
    variables() {
      const { remoteProps, defaultProps } = this;
      let result = {};
      //过滤属性列表
      Object.keys(defaultProps).map((k) => {
        result[k] = remoteProps[k] ?? defaultProps[k];
      });
      return result;
    },
  },
  mounted() {
    let updated = this?.file?.pureInfo?.updated || 0;
    let url = this.remote.src + (updated ? '?r=' + updated : '');
    loadJS(url, () => {
      if (this.mode) return;
      this.rocketEmit('rocket:remote:load-component:' + this.modeName);
    });
    if (this.modeName) {
      // 监听远程组件加载，当页面有多次加载同一组件时，只触发一次
      this.mountComponent();
      if (this.mode) return;
      this.rocketOn(
        'rocket:remote:load-component:' + this.modeName,
        false,
        () => {
          this.mountComponent();
        }
      );
    }
  },
  methods: {
    mountComponent() {
      let name = this.modeName;
      if (!window[name]) return;

      this.mode = window[name];
      this.initProps();
      this.rocketOff('rocket:remote:load-component:' + this.modeName);
    },
    initProps() {
      const { mode } = this;
      let props = mode?.props;
      if (!props) return;
      let result = {};
      if (Array.isArray(props)) {
        props.map((k) => (result[k] = undefined));
      } else {
        Object.keys(props).map((k) => {
          let v = props[k];
          if (v?.type !== Function) {
            if (v?.hasOwnProperty('default')) {
              if (typeof v.default === 'function') {
                result[k] = v.default();
              } else {
                result[k] = v.default;
              }
            } else {
              result[k] = '';
            }
          }
        });
      }
      if (JSON.stringify(result) === JSON.stringify(this.defaultProps)) return;
      this.defaultProps = result;
    },
  },
};
